import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  exteriorHelperText: {
    margin: [`-${theme.spacing('small')}`, theme.spacing('large'), theme.spacing('xlarge')],
  },
  error: {
    padding: [0, theme.spacing('small')],
    marginBottom: theme.spacing('medium'),
  },
}));
